var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPopular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.903,
    height: 43.807,
    viewBox: "1239 321 21.903 43.807",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1249.952 321c-6.024 0-10.952 4.928-10.952 10.952 0 6.023 4.928 10.951 10.952 10.951 6.023 0 10.951-4.928 10.951-10.951 0-6.024-4.928-10.952-10.951-10.952Zm-5.476 26.339v17.468l5.476-5.476 5.476 5.476v-17.468c-1.698.602-3.56 1.04-5.476 1.04-1.917 0-3.779-.438-5.476-1.04Z",
    fill: "#a1a3ef",
    fillRule: "evenodd",
    "data-name": "Icon open-badge"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopular);
export default __webpack_public_path__ + "static/media/Popular.05b1d70c4d892adb80f24adf594083f0.svg";
export { ForwardRef as ReactComponent };